export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '__VIEW_FOCUS_DETAILS': 'View Focus Details'
};
